import { JWTProvider as AuthProvider } from "contexts/JWTContext";
import ThemeCustomization from "./themes";
import Locales from "./components/Locales";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import Notistack from "components/third-party/Notistack";
import Snackbar from "components/@extended/Snackbar";
import ScrollTop from "components/ScrollTop";
import Router from "routes";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ToolsProvider from "contexts/ToolsProvider";
import ThemeSync from "components/ThemeSync";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";

dayjs.extend(utc);
dayjs.extend(timezone);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

function App() {
  return (
    <ThemeCustomization>
      <Locales>
        <ScrollTop>
          <AuthProvider>
            <Notistack>
              <QueryClientProvider client={queryClient}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <ToolsProvider>
                    <ThemeSync />
                    <Router />
                    <Snackbar />
                    <ReactQueryDevtools initialIsOpen={false} />
                  </ToolsProvider>
                </LocalizationProvider>
              </QueryClientProvider>
            </Notistack>
          </AuthProvider>
        </ScrollTop>
      </Locales>
    </ThemeCustomization>
  );
}

export default App;
